<template lang="pug">
  span
    span(
        v-for="(group, index) in groups",
        :key="group.id",
        :class="{'bcard-usergroup-def': group.id === defgroup}")
      | {{(index ? ', ' : '') + group.name}}
</template>

<script>
export default {
  name: 'UserGroups',
  props: {
    defgroup: {type: String, required: true},
    groups: {type: Array, required: true}
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/molecules/UserGroups.vue